import { render, staticRenderFns } from "./workStandardDetailWork.vue?vue&type=template&id=caf9d5e6"
import script from "./workStandardDetailWork.vue?vue&type=script&lang=js"
export * from "./workStandardDetailWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf9d5e6')) {
      api.createRecord('caf9d5e6', component.options)
    } else {
      api.reload('caf9d5e6', component.options)
    }
    module.hot.accept("./workStandardDetailWork.vue?vue&type=template&id=caf9d5e6", function () {
      api.rerender('caf9d5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/sws/workStandardDetailWork.vue"
export default component.exports